
import type { RouteObject } from 'react-router';
import HomePage from '../pages/home/page';
import ShopPage from '../pages/shop/page';
import ContactPage from '../pages/contact/page';
import ProductPage from '../pages/product/page';
import DealsPage from '../pages/deals/page';
import NotificationsPage from '../pages/notifications/page';
import ComparePage from '../pages/compare/page';
import AdminPage from '../pages/admin/page';
import CategoriesPage from '../pages/categories/page';
import ExtensionPage from '../pages/extension/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/deals',
    element: <DealsPage />,
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '/compare',
    element: <ComparePage />,
  },
  {
    path: '/categories',
    element: <CategoriesPage />,
  },
  {
    path: '/extension',
    element: <ExtensionPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
